import { useRefuseWhileViewerOpening } from '~/hooks/useRefuseWhileViewerOpening';
import useProcessDicomFiles from '~/hooks/useProcessDicomFiles';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';
import LocalFilesLoadButton from './LocalFilesLoadButton';
import { Box } from '@mui/material';
import LocalFolderLoadButton from './LocalFolderLoadButton';
import { enqueueSnackbar } from '~/utils/notifications';

export const MAX_FILES = 2000;

const LocalFilesExplorerTab = () => {
    const { initializeEnvironment } = useViewportEnvironment();
    const { processImportedFiles } = useProcessDicomFiles();
    const refuseWhileOpening = useRefuseWhileViewerOpening();

    const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (refuseWhileOpening()) {
            // Clear so re-selecting the same files fires a change event.
            e.target.value = '';
            return;
        }
        if (e.target.files && e.target.files[0]) {
            const files = Array.from(e.target.files);
            if (files.length > MAX_FILES) {
                enqueueSnackbar(
                    `Loading canceled: too many files selected. Limit is ${MAX_FILES}.`,
                    { variant: 'error' }
                );
                return;
            }
            const processedItems = await processImportedFiles(files);
            if (processedItems) {
                initializeEnvironment(processedItems);
            }
        }
    };
    return (
        <>
            <Box
                display="flex"
                flexDirection="column"
                gap={2}
                justifyContent="center"
            >
                <LocalFilesLoadButton onFilesChange={handleFileChange} />
                <LocalFolderLoadButton onFilesChange={handleFileChange} />
            </Box>
        </>
    );
};

export default LocalFilesExplorerTab;
